export const LOAD_FEATURES = 'LOAD_FEATURES';
export const FETCH_FEATURES = 'FETCH_FEATURES';
export const RECEIVED_FEATURES = 'RECEIVED_FEATURES';
export const ERROR_FETCH_FEATURES = 'ERROR_FETCH_FEATURES';
export const SET_FEATURES = 'SET_FEATURES';
